import DialogTitleWithX from './DialogTitleWithX';

export default DialogTitleWithX;
